function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, .summary-element, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ).filter((element) => element.offsetParent !== null);
}

/*
document.querySelectorAll('[id^="Details-"] .summary-element').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {

    console.log("submenu toggle");
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('.details-element').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});
*/

// Header links
document.querySelectorAll('.doen-nav .nav-item__link[href="#"]').forEach(link => {
  link.addEventListener('click', e => e.preventDefault());
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  if(container.classList.contains('mobile-facets__disclosure')) {
    first = container.querySelector('.mobile-facets__close-wrapper');
    first.focus();
    setTimeout(function() {
      first.focus();
    },250)
    last = container.querySelector('button.apply-filters');
  }

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('.details-element[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('.summary-element');
  openDetailsElement.removeAttribute('open');

  //summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('.details-element');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    // Facet refreshes retain some buttons and replace others. Reuse listeners so
    // retained controls still toggle exactly once after any number of refreshes.
    this.boundSummaryClick = this.boundSummaryClick || this.onSummaryClick.bind(this);
    this.boundCloseButtonClick = this.boundCloseButtonClick || this.onCloseButtonClick.bind(this);
    this.querySelectorAll('.summary-element').forEach(summary => summary.addEventListener('click', this.boundSummaryClick));
    this.querySelectorAll('button:not(.summary-element)').forEach(button => button.addEventListener('click', this.boundCloseButtonClick));

    if (this.classList.contains('mobile-facets__wrapper')) {
      this.querySelectorAll('.summary-element').forEach(summary => {
        summary.setAttribute('aria-expanded', summary.parentElement.classList.contains('menu-opening'));
        const panel = summary.nextElementSibling;
        if (panel && panel.id) summary.setAttribute('aria-controls', panel.id);
      });
      if (this.mainDetailsToggle.classList.contains('menu-opening')) {
        const dialog = this.querySelector('.mobile-facets__inner');
        // Recompute the focus boundaries after controls have been replaced.
        trapFocus(dialog, dialog.contains(document.activeElement) ? document.activeElement : this.querySelector('.mobile-facets__close-wrapper'));
      }
    }
  }

  connectedCallback() {
    if (!this.classList.contains('mobile-facets__wrapper')) return;
    this.boundOutsideClick = this.boundOutsideClick || ((event) => {
      if (this.mainDetailsToggle.classList.contains('menu-opening') && !this.contains(event.target)) {
        this.setFacetDrawerOpen(false);
      }
    });
    document.addEventListener('click', this.boundOutsideClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.boundOutsideClick);
    clearTimeout(this.facetCloseTimer);
    if (this.classList.contains('mobile-facets__wrapper') && this.mainDetailsToggle.hasAttribute('open')) {
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus();
    }
  }

  setFacetDrawerOpen(open, returnFocus = true) {
    clearTimeout(this.facetCloseTimer);
    const summary = this.querySelector('.mobile-facets__open-wrapper');
    const dialog = this.querySelector('.mobile-facets__inner');
    summary.setAttribute('aria-expanded', open);
    this.mainDetailsToggle.classList.toggle('menu-opening', open);
    document.body.classList.toggle('overflow-hidden', open);

    if (open) {
      this.mainDetailsToggle.setAttribute('open', '');
      dialog.inert = false;
      trapFocus(dialog, this.querySelector('.mobile-facets__close-wrapper'));
    } else {
      dialog.inert = true;
      removeTrapFocus(returnFocus ? summary : undefined);
      this.mainDetailsToggle.querySelectorAll('.details-element').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
        details.querySelector('.summary-element')?.setAttribute('aria-expanded', false);
      });
      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => submenu.classList.remove('submenu-open'));
      // Keep the panel mounted for its exit transition, but cancel this removal
      // if the shopper reopens it before the animation finishes.
      this.facetCloseTimer = setTimeout(() => this.mainDetailsToggle.removeAttribute('open'), 400);
    }
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    if (this.classList.contains('mobile-facets__wrapper')) {
      if (this.mainDetailsToggle.classList.contains('menu-opening')) {
        event.preventDefault();
        event.stopPropagation();
        this.setFacetDrawerOpen(false);
      }
      return;
    }

    const openDetailsElement = event.target.closest('.details-element[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('.summary-element')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');

    if (this.classList.contains('mobile-facets__wrapper')) {
      event.preventDefault();
      if (detailsElement === this.mainDetailsToggle) {
        this.setFacetDrawerOpen(!detailsElement.classList.contains('menu-opening'));
      } else {
        detailsElement.toggleAttribute('open', !isOpen);
        detailsElement.classList.toggle('menu-opening', !isOpen);
        summaryElement.setAttribute('aria-expanded', !isOpen);
      }
      return;
    }
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      //trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      trapFocus(summaryElement.nextElementSibling);
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        if(detailsElement.hasAttribute('open')) {
          detailsElement.classList.remove('menu-opening');
          detailsElement.removeAttribute('open');

          //summaryElement.setAttribute('aria-expanded', false);
          parentMenuElement && parentMenuElement.classList.remove('submenu-open');
          removeTrapFocus(detailsElement);
        } else {
          detailsElement.setAttribute('open', true);
          detailsElement.classList.add('menu-opening');

          //summaryElement.setAttribute('aria-expanded', true);
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
          !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }
        
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.setAttribute('open', true)
    });
    //summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
    var _this = this;
    setTimeout(function() {
      _this.mainDetailsToggle.classList.add('menu-opening');
    }, 50);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('.details-element').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.classList.contains('mobile-facets__wrapper')) {
        if (this.mainDetailsToggle.classList.contains('menu-opening') && !this.contains(document.activeElement)) {
          this.setFacetDrawerOpen(false, false);
        }
        return;
      }
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    if (this.classList.contains('mobile-facets__wrapper')) {
      this.setFacetDrawerOpen(false);
      return;
    }
    const detailsElement = event.currentTarget.closest('.details-element');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    if(detailsElement.classList.contains('mobile-facets__disclosure')) {
      setTimeout(function() {
        detailsElement.removeAttribute('open');
        document.body.classList.remove(`overflow-hidden`);
      }, 200);
    } else {
      detailsElement.removeAttribute('open');
    }
    //detailsElement.querySelector('.summary-element').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('.summary-element'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('.details-element[open]')) {
          trapFocus(detailsElement.closest('.details-element[open]'), detailsElement.querySelector('.summary-element'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.setAttribute('open',true);
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    
    //summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.sliderControlButtons = Array.from(this.querySelectorAll('.slider-counter__link'));
    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));

    if (this.sliderControlButtons.length) {
      this.sliderControlButtons.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    } 

    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  
    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round((this.slider.scrollLeft / this.sliderItemOffset) || 0) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.sliderControlButtons.length) {
      this.sliderControlButtons.forEach(link => {
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });

      const activeControlButton = this.sliderControlButtons[this.currentPage - 1];

      if (activeControlButton) {
        this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
        this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
      }
    }

    if (this.enableSliderLooping) return;

    if (this.prevButton) {
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
    }

    if (this.nextButton) {
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlButtons.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.enableSliderLooping = true;

    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

function initializeProductTabKeyboard(scope = document) {
  scope.querySelectorAll('.product__tabs__header').forEach((tablist) => {
    if (tablist.dataset.tabsKeyboardInitialized === 'true') return;

    tablist.dataset.tabsKeyboardInitialized = 'true';
    tablist.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      const tabs = Array.from(tablist.querySelectorAll('.product__tab:not([disabled="true"])'));
      if (!tabs.length) return;

      const activeTab = tablist.querySelector('.product__tab[aria-selected="true"]') || tabs[0];
      const activeIndex = tabs.indexOf(activeTab);
      const nextIndex = event.key === 'ArrowLeft'
        ? (activeIndex > 0 ? activeIndex - 1 : tabs.length - 1)
        : (activeIndex < tabs.length - 1 ? activeIndex + 1 : 0);

      event.preventDefault();
      tabs.forEach((tab, index) => {
        const isActive = index === nextIndex;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      tabs[nextIndex].focus();
    });
  });
}

window.initializeProductTabKeyboard = initializeProductTabKeyboard;

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.elementRole = this.dataset.role || 'primary';
    this.linkedProductAbortController = null;
    this.addEventListener('change', this.onVariantChange);
    this.addEventListener('click', this.onLinkedProductClick.bind(this));
  }

  onVariantChange() {
    this.updateOptions();

    if (this.elementRole === 'secondary') return;

    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      // The button state only depends on the variant data, so set it now instead of after the price fetch.
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  onLinkedProductClick(event) {
    const linkedProductTrigger = event.target.closest('[data-linked-product]');
    if (!linkedProductTrigger || !this.contains(linkedProductTrigger)) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();

    if (linkedProductTrigger.classList.contains('is-active')) return;

    this.switchLinkedProduct(linkedProductTrigger);
  }

  getSectionId() {
    return this.dataset.originalSection || this.dataset.section;
  }

  getSelectedSizeValue(sizeOptionIndex) {
    const selectedSize = this.querySelector('fieldset[data-option="size"] input:checked')?.value;
    if (selectedSize) return selectedSize;
    if (typeof sizeOptionIndex !== 'number' || Number.isNaN(sizeOptionIndex)) return null;

    this.updateOptions();
    this.updateMasterId();
    return this.currentVariant?.options?.[sizeOptionIndex] || null;
  }

  getLinkedProductUrl(linkedProductTrigger) {
    const fallbackUrl = linkedProductTrigger.getAttribute('href') || linkedProductTrigger.dataset.productUrl || this.dataset.url;
    const sizeOptionIndex = parseInt(linkedProductTrigger.dataset.sizeOptionIndex, 10);
    const selectedSize = this.getSelectedSizeValue(sizeOptionIndex);

    if (!selectedSize || !linkedProductTrigger.dataset.variants) return fallbackUrl;

    try {
      const variantMap = JSON.parse(linkedProductTrigger.dataset.variants);
      return variantMap[selectedSize]?.url || fallbackUrl;
    } catch (error) {
      console.error('Failed to parse linked product variants', error);
      return fallbackUrl;
    }
  }

  async switchLinkedProduct(linkedProductTrigger) {
    const nextUrl = this.getLinkedProductUrl(linkedProductTrigger);
    const requestUrl = new URL(nextUrl, window.location.origin);
    const sectionId = this.getSectionId();
    const currentSection = document.getElementById(`MainProduct-${sectionId}`);

    if (!currentSection) {
      window.location.assign(requestUrl.pathname + requestUrl.search);
      return;
    }

    if (this.linkedProductAbortController) {
      this.linkedProductAbortController.abort();
    }

    const abortController = new AbortController();
    this.linkedProductAbortController = abortController;
    requestUrl.searchParams.set('section_id', sectionId);

    currentSection.setAttribute('aria-busy', 'true');
    currentSection.classList.add('is-switching-linked-product');

    try {
      const response = await fetch(requestUrl.toString(), {
        signal: abortController.signal,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to load linked product section: ${response.status}`);
      }

      const responseText = await response.text();
      this.replaceLinkedProductContent(responseText, nextUrl, linkedProductTrigger.dataset.color);
    } catch (error) {
      if (error.name === 'AbortError') return;

      console.error(error);
      window.location.assign(new URL(nextUrl, window.location.origin).pathname + new URL(nextUrl, window.location.origin).search);
    } finally {
      if (this.linkedProductAbortController === abortController) {
        this.linkedProductAbortController = null;
      }

      currentSection.removeAttribute('aria-busy');
      currentSection.classList.remove('is-switching-linked-product');
    }
  }

  replaceLinkedProductContent(responseText, nextUrl, selectedColor) {
    const sectionId = this.getSectionId();
    const parsedHtml = new DOMParser().parseFromString(responseText, 'text/html');
    const currentSection = document.getElementById(`MainProduct-${sectionId}`);
    const currentProduct = currentSection?.querySelector('.product');
    const nextProduct = parsedHtml.querySelector(`#MainProduct-${sectionId} .product`) || parsedHtml.querySelector('.product');

    if (!currentSection || !currentProduct || !nextProduct) {
      throw new Error('Unable to replace linked product content');
    }

    window.pauseAllMedia();

    const stickyAtc = currentSection.querySelector('sticky-atc');
    if (stickyAtc && typeof stickyAtc.collapse === 'function') {
      stickyAtc.collapse();
    }

    const currentKlarnaPlacement = currentProduct.querySelector('klarna-placement[data-locale]');
    const nextKlarnaPlacement = nextProduct.querySelector('klarna-placement');
    const nextKlarnaPurchaseAmount = nextKlarnaPlacement?.getAttribute('data-purchase-amount');
    if (nextKlarnaPlacement) {
      const klarnaPlaceholder = parsedHtml.createElement('span');
      klarnaPlaceholder.hidden = true;
      klarnaPlaceholder.dataset.klarnaPlacementPlaceholder = '';
      nextKlarnaPlacement.replaceWith(klarnaPlaceholder);
    }

    currentProduct.outerHTML = nextProduct.outerHTML;

    const klarnaPlaceholder = currentSection.querySelector('.product [data-klarna-placement-placeholder]');
    if (klarnaPlaceholder) {
      if (currentKlarnaPlacement) {
        if (nextKlarnaPurchaseAmount !== null) {
          currentKlarnaPlacement.setAttribute('data-purchase-amount', nextKlarnaPurchaseAmount);
        }
        klarnaPlaceholder.replaceWith(currentKlarnaPlacement);
      } else {
        klarnaPlaceholder.remove();
      }
    }

    const currentModal = document.getElementById(`ProductModal-${sectionId}`);
    const nextModal = parsedHtml.getElementById(`ProductModal-${sectionId}`);
    if (currentModal && nextModal) {
      currentModal.outerHTML = nextModal.outerHTML;
    }

    document.body.classList.remove('has-overlay');

    const normalizedUrl = new URL(nextUrl, window.location.origin);
    window.history.replaceState({}, '', `${normalizedUrl.pathname}${normalizedUrl.search}`);

    const nextDocumentTitle = nextProduct.dataset.documentTitle;
    if (nextDocumentTitle) document.title = nextDocumentTitle;

    const updatedSection = document.getElementById(`MainProduct-${sectionId}`);
    if (updatedSection) {
      initializeProductTabKeyboard(updatedSection);

      if (window.SizeGuide && typeof window.SizeGuide.refresh === 'function') {
        window.SizeGuide.refresh(updatedSection);
      }

      const activeSwatch = Array.from(updatedSection.querySelectorAll('[data-linked-product]')).find((swatch) => {
        return swatch.dataset.color === selectedColor && swatch.getAttribute('aria-current') === 'true';
      }) || updatedSection.querySelector('[data-linked-product].is-active');

      if (activeSwatch) {
        activeSwatch.focus();
      }
    }

    const waitlistModal = document.querySelector('waitlist-modal');
    if (waitlistModal && typeof waitlistModal.refreshTriggers === 'function') {
      waitlistModal.refreshTriggers();
    }

    document.body.dispatchEvent(new CustomEvent('linkedProduct:swapped', {
      detail: {
        sectionId,
        url: `${normalizedUrl.pathname}${normalizedUrl.search}`
      }
    }));

    this.refreshThirdPartyWidgets(updatedSection, normalizedUrl);
  }

  refreshThirdPartyWidgets(section, productUrl) {
    if (!section) return;

    const activeVariantControl = section.querySelector('variant-radios[data-role="primary"], variant-selects[data-role="primary"], variant-radios, variant-selects');

    if (activeVariantControl && typeof activeVariantControl.updateOptions === 'function') {
      activeVariantControl.updateOptions();
    }

    if (activeVariantControl && typeof activeVariantControl.updateMasterId === 'function') {
      activeVariantControl.updateMasterId();
    }

    if (typeof window.initializeMainProductInstallments === 'function') {
      window.initializeMainProductInstallments(section);
    }

    if (
      section.querySelector('klarna-placement') &&
      window.Klarna?.OnsiteMessaging &&
      typeof window.Klarna.OnsiteMessaging.refresh === 'function'
    ) {
      window.Klarna.OnsiteMessaging.refresh();
    }

    if (typeof window.initializeDoenProductVideos === 'function') {
      window.initializeDoenProductVideos(section);
    }

    this.normalizeProductCtaVisibility(section);

    if (activeVariantControl && typeof activeVariantControl.syncBisTrigger === 'function') {
      activeVariantControl.syncBisTrigger();

      [100, 300].forEach((delay) => {
        window.setTimeout(() => {
          if (!activeVariantControl.isConnected) return;
          if (typeof activeVariantControl.updateOptions === 'function') {
            activeVariantControl.updateOptions();
          }
          if (typeof activeVariantControl.updateMasterId === 'function') {
            activeVariantControl.updateMasterId();
          }
          activeVariantControl.syncBisTrigger();
        }, delay);
      });
    }
  }

  normalizeProductCtaVisibility(section) {
    const productRoot = section?.querySelector('.product');
    if (!productRoot) return;

    const addButtons = productRoot.querySelectorAll('[name="add"]');
    const waitlistButtons = productRoot.querySelectorAll('[name="waitlist"]');
    if (!addButtons.length && !waitlistButtons.length) return;

    const variantSelect = productRoot.querySelector('variant-radios, variant-selects');
    const hasSelectedSize = Boolean(variantSelect?.querySelector('.option-type--size input:checked'));
    const currentVariant = variantSelect?.currentVariant || null;
    const shouldShowWaitlist = Boolean(hasSelectedSize && currentVariant && currentVariant.available === false);

    addButtons.forEach((button) => {
      button.setAttribute('aria-hidden', shouldShowWaitlist ? 'true' : 'false');
    });

    waitlistButtons.forEach((button) => {
      button.setAttribute('aria-hidden', shouldShowWaitlist ? 'false' : 'true');
    });
  }

  getProductHandle(productUrl) {
    const normalizedUrl = productUrl instanceof URL ? productUrl : new URL(productUrl, window.location.origin);
    const match = normalizedUrl.pathname.match(/\/products\/([^/]+)/);
    return match ? match[1] : null;
  }

  fetchProductJson(productUrl) {
    const handle = this.getProductHandle(productUrl || this.dataset.url || window.location.pathname);
    if (!handle) return Promise.reject(new Error('Missing product handle'));

    window.__shopdoenProductCache = window.__shopdoenProductCache || new Map();
    if (!window.__shopdoenProductCache.has(handle)) {
      window.__shopdoenProductCache.set(handle, fetch(`/products/${handle}.js`).then((res) => {
        if (!res.ok) throw new Error(`Failed to fetch product JSON: ${res.status}`);
        return res.json();
      }));
    }

    return window.__shopdoenProductCache.get(handle);
  }

  syncBisTrigger() {
    const productRoot = this.closest('.product');
    if (!productRoot) return;

    const buttonContainer = productRoot.querySelector('.product-form__buttons--main');
    const currentBisTrigger = productRoot.querySelector('#BIS_trigger');
    const shouldShowBis = Boolean(this.currentVariant && !this.currentVariant.available);

    if (!buttonContainer) return;

    if (!shouldShowBis) {
      productRoot.bisSyncKey = null;
      productRoot.bisSyncPending = false;
      productRoot.bisSyncRequestId = (productRoot.bisSyncRequestId || 0) + 1;

      if (currentBisTrigger?.dataset.linkedProductFallback === 'true') {
        currentBisTrigger.remove();
      } else if (currentBisTrigger?.style.display !== 'none') {
        currentBisTrigger.style.display = 'none';
      }
      return;
    }

    const variantId = String(this.currentVariant.id);
    const syncKey = `${this.dataset.url || window.location.pathname}:${variantId}`;
    const triggerIsCurrent = currentBisTrigger?.getAttribute('data-variant-id') === variantId;

    if (productRoot.bisSyncKey === syncKey && (productRoot.bisSyncPending || triggerIsCurrent)) return;

    productRoot.bisSyncKey = syncKey;
    productRoot.bisSyncPending = true;
    productRoot.bisSyncRequestId = (productRoot.bisSyncRequestId || 0) + 1;
    const requestId = productRoot.bisSyncRequestId;

    const applyBisTrigger = (productData) => {
      if (!productRoot.isConnected || productRoot.bisSyncRequestId !== requestId) return;

      const trigger = productRoot.querySelector('#BIS_trigger') || document.createElement('button');
      const productDataJson = JSON.stringify(productData);

      if (!trigger.parentNode) {
        trigger.id = 'BIS_trigger';
        trigger.className = 'button BIS_trigger';
        trigger.type = 'button';
        trigger.dataset.linkedProductFallback = 'true';
        trigger.textContent = window.variantStrings?.joinWaitlist || 'Join waitlist';
        trigger.addEventListener('click', (event) => {
          // Every popup AMP has built on this page (including the previous colour's) listens on document
          // for #BIS_trigger clicks, so stop this click there and open only the current product's popup
          // through AMP's generic .BIS_trigger handler, the same way gw-quick-add-availability.js does.
          event.preventDefault();
          event.stopPropagation();

          const proxyTrigger = document.createElement('button');
          proxyTrigger.type = 'button';
          proxyTrigger.className = 'BIS_trigger';
          proxyTrigger.setAttribute('data-product-data', trigger.getAttribute('data-product-data'));
          proxyTrigger.setAttribute('data-variant-id', trigger.getAttribute('data-variant-id'));
          proxyTrigger.style.display = 'none';
          document.body.appendChild(proxyTrigger);
          proxyTrigger.click();
          setTimeout(() => proxyTrigger.remove(), 500);
        });
        buttonContainer.parentNode.insertBefore(trigger, buttonContainer);
      }

      if (trigger.getAttribute('data-product-data') !== productDataJson) {
        trigger.setAttribute('data-product-data', productDataJson);
      }
      if (trigger.getAttribute('data-variant-id') !== variantId) {
        trigger.setAttribute('data-variant-id', variantId);
      }
      if (trigger.style.display === 'none') {
        trigger.style.display = '';
      }

      productRoot.bisSyncPending = false;
    };

    // AMP Back in Stock needs Shopify's /products/<handle>.js shape (variants as an array);
    // the embedded [data-product-data] block is the Favorites payload (variants.nodes) and breaks it.
    this.fetchProductJson(this.dataset.url || window.location.pathname)
      .then((productData) => applyBisTrigger(productData))
      .catch((error) => {
        if (productRoot.bisSyncRequestId === requestId) {
          productRoot.bisSyncKey = null;
          productRoot.bisSyncPending = false;
        }
        console.error('Failed to sync BIS trigger:', error);
      });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-${this.dataset.section}-sticky, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      // Purple Dot can retain its previous state on variants outside its pre-order release.
      productForm.dataset.variantInStock = this.currentVariant.available &&
        (!this.currentVariant.inventory_management || this.currentVariant.inventory_quantity > 0);
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      window.ShopdoenCompareAtLineItemProperty?.syncForm(productForm, this.currentVariant);
    });

    this.updateWishlistButton();
  }

  updateWishlistButton() {
    if (!this.currentVariant) return;

    const section = this.closest('section');
    if (!section) return;

    const wishlistButton = section.querySelector('gw-wishlist-button.card__wishlist-button');
    if (!wishlistButton) return;

    wishlistButton.setAttribute('variant-id', this.currentVariant.id);

    const productDataScript = wishlistButton.querySelector('[data-product-data]');
    if (!productDataScript) return;

    try {
      const productData = JSON.parse(productDataScript.textContent);

      productData.variantId = String(this.currentVariant.id);
      productData.variantTitle = this.currentVariant.title;

      productDataScript.textContent = JSON.stringify(productData, null, 2);
    } catch (error) {
      console.warn('Unable to update wishlist product data for selected variant.', error);
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {

    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButtons = this.closest('.product').querySelectorAll('[name="add"]');
    this.closest('.product').classList.remove('no-product-variant-selected');
    if (!addButtons.length) return;
    const waitlistButtons = this.closest('.product').querySelectorAll('[name="waitlist"]');
    const giftcard = document.querySelector('body.product-giftcard');

    // Check if max quantity is reached for this product
    let maxQuantityReached = false;
    const firstAddButton = addButtons[0];
    if (firstAddButton && firstAddButton.dataset.productId && window.MaxQuantityTracker) {
      const productId = parseInt(firstAddButton.dataset.productId);
      maxQuantityReached = window.MaxQuantityTracker.isMaxReached(productId);
    }
    
    if (disable) {
      addButtons.forEach(addButton => {
        addButton.setAttribute('disabled', 'disabled');
        const addButtonText = addButton.querySelector('span');
        // If max quantity reached, always show "Limit Reached" text
        if (maxQuantityReached) {
          addButtonText.textContent = window.MaxQuantityTracker.MAX_REACHED_TEXT;
          addButton.classList.add('max-quantity-reached');
        } else if (text) {
          addButtonText.textContent = text;
        }
        
        if (!giftcard) {
          if (this.currentVariant && this.currentVariant.available === false) {
            addButton.setAttribute('aria-hidden', 'true');

            document.querySelector('variant-radios').querySelectorAll('input.force-available').forEach(element => {
              element.classList.remove('force-available')
            });
            this.setSizeClasses()
          } else {
            this.setSizeClasses()
          }
        }
      });

      if (!giftcard) {
        if (this.currentVariant && this.currentVariant.available === false) {
          waitlistButtons.forEach(button => button.setAttribute('aria-hidden', 'false'));
          this.setSizeClasses()
        } else {
          this.setSizeClasses()
        }
      }
    } else {
      // If max quantity reached, keep button disabled regardless of variant availability
      if (maxQuantityReached) {
        addButtons.forEach(addButton => {
          addButton.setAttribute('disabled', 'disabled');
          addButton.classList.add('max-quantity-reached');
          const addButtonText = addButton.querySelector('span');
          if (addButtonText) {
            addButtonText.textContent = window.MaxQuantityTracker.MAX_REACHED_TEXT;
          }
        });
        // Still need to handle size classes
        if (!giftcard) {
          this.setSizeClasses();
        }
      } else {
        addButtons.forEach(addButton => {
          addButton.removeAttribute('disabled');
          addButton.classList.remove('max-quantity-reached', 'disabled');
          const addButtonText = addButton.querySelector('span');

          if(!giftcard) {
            if (text) addButtonText.textContent = window.variantStrings.addToCart;

            document.querySelector('variant-radios').querySelectorAll('input:checked').forEach(element => {
              if(element.classList.contains('is-unavailable')) {
                element.classList.add('force-available')
              }
            });
            document.querySelector('variant-radios').querySelectorAll('input.force-available:not(:checked)').forEach(element => {
              element.classList.remove('force-available')
            });
            this.setSizeClasses();
  
            if (this.currentVariant.available) {
              addButton.setAttribute('aria-hidden', 'false');
            }
          }
        });

        if(!giftcard) {
          if (this.currentVariant.available) {
            waitlistButtons.forEach(button => button.setAttribute('aria-hidden', 'true'));
          }
        }
      }
    }

    if(document.querySelector('.product__expected.expected-ship-date')) {
      if(this.currentVariant.inventory_quantity <= 0) {
          document.querySelector('.product__expected.expected-ship-date').classList.remove('visibility-hidden');
      } else {
          document.querySelector('.product__expected.expected-ship-date').classList.add('visibility-hidden');
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getVariantId() {
    return this.currentVariant?.id
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.fieldsets = this.querySelectorAll('fieldset');
    this.setSizeClasses();
    this.updateOptions();
    this.updateMasterId();
  }

  setSizeClasses() {
    const sizeFieldset = this.querySelector('.option-type--size');

    if (!sizeFieldset) return;

    const sizeInputs = sizeFieldset.querySelectorAll('input');
    const sizesKey = sizeFieldset.dataset.optionId;
    var hasSelectedMonogram = false;
    if(document.querySelector('.product-form__input[data-option="monogram"] input:checked')) {
      hasSelectedMonogram = document.querySelector('.product-form__input[data-option="monogram"] input:checked').value;
    }
    document.querySelector('variant-radios').querySelectorAll('input.force-available').forEach(element => {
      element.classList.remove('force-available')
    });
    for (const sizeInput of sizeInputs) {
      const possibleVariants = this.getVariantData().filter(variant => variant[sizesKey] === sizeInput.value);
      // Shopify marks continue-selling variants available even when Purple Dot
      // cannot sell their pre-order in the shopper's market.
      const marketUnavailable = document.documentElement.classList.contains('preorder-market-unavailable') &&
        possibleVariants.length > 0 && possibleVariants.every(variant =>
          !variant.available || (variant.inventory_policy === 'continue' && variant.inventory_quantity <= 0)
        );
      sizeInput.classList.toggle('is-market-unavailable', marketUnavailable);
      const marketLabel = sizeInput.nextElementSibling.querySelector('[data-market-unavailable]');
      if (marketUnavailable && !marketLabel && !sizeInput.nextElementSibling.querySelector('.visually-hidden')) {
        const label = document.createElement('span');
        label.className = 'visually-hidden';
        label.dataset.marketUnavailable = '';
        label.textContent = ` ${window.variantStrings.unavailable}`;
        sizeInput.nextElementSibling.append(label);
      } else if (!marketUnavailable) {
        marketLabel?.remove();
      }
      for (let variant of possibleVariants) {
        if (!variant.available && !sizeInput.classList.contains('is-delivery')) {
          sizeInput.classList.add('is-unavailable');
          if(!sizeInput.nextElementSibling.querySelector('span.visually-hidden')) {
            sizeInput.nextElementSibling.innerHTML += ' <span class="visually-hidden">unavailable</span>';
          }
        }
        if(variant.available && hasSelectedMonogram && hasSelectedMonogram == variant.option2) {
          sizeInput.classList.add('force-available');
        }
      }
    }
  }

  updateRadios() {
    const giftcard = document.querySelector('body.product-giftcard');

    if(!giftcard) {
      this.fieldsets.forEach(fieldset => {
        const option = fieldset.dataset.option;
        const twinFieldsets = Array.from(document.querySelectorAll(`variant-radios fieldset[data-option="${option}"]`)).filter(el => el !== fieldset);
  
        if (twinFieldsets.length) {
          const inputs = fieldset.querySelectorAll('input');
          const selected = Array.from(inputs).find(input => input.checked);
  
          if (!selected) return;
  
          twinFieldsets.forEach(twin => {
            const twinInputs = twin.querySelectorAll('input');
  
            twinInputs.forEach(input => {
              if (input.value === selected.value) {
                input.checked = true;
              }
            });
          });
        }
      });
    }
  }

  updateOptions() {
    this.updateRadios();
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
